export const fontsVkSans = [
  {
    style: "normal",
    urlSet: [{ format: "truetype", url: "/fonts/VKSansDisplay-Regular.ttf" }],
    weight: "400",
  },
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/VKSansDisplay-Medium.ttf",
      },
    ],
    weight: "500",
  },
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/VKSansDisplay-DemiBold.ttf",
      },
    ],
    weight: "600",
  },
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/VKSansDisplay-Bold.ttf",
      },
    ],
    weight: "700",
  },
];
